import { Box, Typography, Container, Chip, Stack } from "@mui/material";

const HeroSection = () => (
  <Box
    sx={{
      textAlign: "center",
      py: 10,
      bgcolor: "background.paper",
    }}
  >
    <Container maxWidth="md">
      <Typography variant="h3" fontWeight={700} gutterBottom>
        Craig Lawlor
      </Typography>
      <Typography variant="h5" color="text.secondary" fontWeight={400} sx={{ fontFamily: "body1.fontFamily" }} gutterBottom>
        Software Developer | UX Designer
      </Typography>
      <Stack
        direction="row"
        spacing={1}
        justifyContent="center"
        flexWrap="wrap"
        sx={{ mt: 2, gap: 1 }}
      >
        {["React", "TypeScript", ".NET", "GraphQL"].map((tech) => (
          <Chip
            key={tech}
            label={tech}
            sx={{
              bgcolor: 'rgba(255,47,146,0.08)',
              color: 'text.primary',
              border: '1px solid rgba(255,47,146,0.35)',
            }}
          />
        ))}
      </Stack>
      <Typography
        variant="body1"
        color="text.primary"
        sx={{ mt: 4, maxWidth: 680, mx: "auto", lineHeight: 1.8 }}
      >
        Full-stack software developer with 6+ years of experience building and
        maintaining modern web and desktop applications. Skilled in developing
        React-based frontends integrated with C# APIs and relational databases,
        with a strong focus on performance, usability, and real-world
        functionality. Experienced in UI/UX design - from early-stage
        prototyping in Figma through to polished, user-centred interfaces -
        bridging the gap between design and implementation across the full stack.
      </Typography>
    </Container>
  </Box>
);

export default HeroSection;
